import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { ForWho } from '../components/ForWho';
import { Promise } from '../components/Promise';
import { ChampionStory } from '../components/ChampionStory';
import { TrainerAuthority } from '../components/TrainerAuthority';
import { TeamResults } from '../components/TeamResults';
import { HowItWorks } from '../components/HowItWorks';
import { WhatIncludes } from '../components/WhatIncludes';
import { Pricing } from '../components/Pricing';
import { Schedule } from '../components/Schedule';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
export function SalesPage() {
  return <div className="w-full min-h-screen bg-[#0a0a0a]" data-id="element-516">
      <Navbar data-id="element-517" />
      <Hero data-id="element-518" />
      <ForWho data-id="element-519" />
      <Promise data-id="element-520" />
      <ChampionStory data-id="element-521" />
      <TrainerAuthority data-id="element-522" />
      <TeamResults data-id="element-523" />
      <HowItWorks data-id="element-524" />
      <WhatIncludes data-id="element-525" />
      <Pricing data-id="element-526" />
      <Schedule data-id="element-527" />
      <FAQ data-id="element-528" />
      <FinalCTA data-id="element-529" />

      {/* Footer */}
      <footer className="w-full bg-[#0a0a0a] border-t border-[#1a1a1a] py-10 px-4" data-id="element-530">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-531">
          <div className="flex items-center gap-3" data-id="element-532">
            <img src="https://cdn.magicpatterns.com/uploads/7KGG45Zf29JRX1VVso6grv/karchek.jpg" alt="Kerchak Fighters Team" className="w-10 h-10 rounded-full object-cover border border-[#C9A84C]/40" data-id="element-533" />
            <div data-id="element-534">
              <p className="font-heading font-bold text-white uppercase text-sm tracking-widest" data-id="element-535">
                Kerchak Fighters Team
              </p>
              <p className="font-body text-[#C9A84C] text-xs tracking-widest" data-id="element-536">
                Boxeo · MMA · K1
              </p>
            </div>
          </div>
          <p className="font-body text-gray-600 text-xs text-center sm:text-right" data-id="element-537">
            © {new Date().getFullYear()} Kerchak Fighters Team. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}